import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { getOrderingSystem, getSelectedOrder } from '../../../../../../../../selectors/tools';
import DTOrderSearchResult from '../DTOrderSearchResult/DTOrderSearchResult';
import { getMappedValueFromOrderOrItem } from '../../../../../../../../util';
import { selectOrder } from '../../../../../../../../actions/tools/OrdersSearchActions';
import { showErrorPopup } from '../../../../../../../popups/ErrorPopup/ErrorPopup';
import { SearchResultsSettingsContext } from '../../SearchResultsSettingsContext';
import DTOrderSearchCustomResult from '../DTOrderSearchResult/DTOrderSearchCustomResult/DTOrderSearchCustomResult';

const DTOrderSearchResultsList = (props) => {
  const { orders } = props;
  const dispatch = useDispatch();

  const orderingSystem = useSelector(getOrderingSystem);
  const selectedOrder = useSelector(getSelectedOrder);
  const { useCustomLayout } = useContext(SearchResultsSettingsContext);
  const selectedOrderId = selectedOrder
    ? getMappedValueFromOrderOrItem(selectedOrder, 'orderId', orderingSystem)
    : null;

  if (!['shopify', 'custom_rbi', 'salesforce', 'bigCommerce', 'revolve', 'common'].includes(String(orderingSystem))) {
    showErrorPopup(`Invalid ordering system!`, 'Error');

    return null;
  }

  const handleCheckOrder = (isChecked, order) => {
    if (isChecked) {
      dispatch(selectOrder(order));
    } else {
      dispatch(selectOrder({}));
    }
  };

  if (isEmpty(orders)) {
    return null;
  }

  const OrderSearchResultComponent = useCustomLayout ? DTOrderSearchCustomResult : DTOrderSearchResult;

  return (
    <>
      {orders.map((order = {}, index) => {
        const orderId = getMappedValueFromOrderOrItem(order, 'orderId', orderingSystem);

        return (
          <OrderSearchResultComponent
            key={`search-result-list-SEARCH_ORDERS_DECISION_TREE-result-${index}`}
            order={order}
            isSelected={orderId === selectedOrderId}
            isLast={index === orders.length - 1}
            onCheckboxClick={handleCheckOrder}
          />
        );
      })}
    </>
  );
};

export default DTOrderSearchResultsList;
